import React from 'react';
import { Switch } from 'react-router-dom';

import TitleHelmet from 'components/Helmets/TitleHelmet';
import DescriptionHelmet from 'components/Helmets/DescriptionHelmet';
import SidebarContentLayout from 'components/SidebarContentLayout';
import SidebarNav from 'components/SidebarNav';
import RouteItem from 'components/RouteItem';
import SiteHeader from 'components/SiteHeader';
import SiteFooter from 'components/SiteFooter';

import {
  SapienLine,
  CortexLine,
} from 'components/Icons';

import {
  demoRoutes,
  __demoHome,
  __demoSapienParsing,
  __demoSapienExtractRelations,
  __demoSapienCompare,
  __demoCortexQueryNL,
} from 'pages/demo/routes';

import { ACCENTS } from 'constants/themes';

const TITLE_HELMET = <TitleHelmet title="Demos · Plasticity Natural Language Processing APIs" />;
const DESCRIPTION_HELMET = <DescriptionHelmet description="See examples of Plasticity's natural language processing APIs in use for entity extraction, tokenization, tagging, and more. Demos include sample text and queries from medical records, customer service help forums, news, and Wikipedia." />;

const Demo = () => {
  const sidebarNavItems = [
    __demoHome,
    {
      nav: {
        text: 'Sapien Language Engine',
        icon: <SapienLine />,
      },
      defaultOpen: true,
      children: [
        __demoSapienParsing,
        __demoSapienExtractRelations,
        __demoSapienCompare,
      ],
    },
    {
      nav: {
        text: 'Cortex Knowledge Graph',
        icon: <CortexLine />,
      },
      defaultOpen: true,
      children: [
        __demoCortexQueryNL,
      ],
    },
  ];

  return (
    <>
      {TITLE_HELMET}
      {DESCRIPTION_HELMET}
      <SiteHeader
        variant="relative"
        theme="dark"
        accent={ACCENTS.blog}
      />
      <SidebarContentLayout
        containerSize="rightStop"
        sidebar={
          <SidebarNav items={sidebarNavItems} />
        }
        content={(
          <Switch>
            {Object.values(demoRoutes).reverse().map((route) => (
              <RouteItem
                key={route.path}
                {...route}
              />
            ))}
          </Switch>
        )}
      />
      <SiteFooter theme="dark" />
    </>
  );
};

export default Demo;
